import { jsx as _jsx } from "react/jsx-runtime";
var OpenPage = function () {
    return _jsx("div", { children: "Open Page (Accessible to all)" });
};
export default OpenPage;
